export const ListFilter = (props: any) => <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" >
  <path d="M1.5 3H10.5M3.5 6H8.5M5 9H7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
</svg >
